<template>
  <div>
    <van-tabbar
      v-model="active"
      :route="true"
      fixed
      :safe-area-inset-bottom="true"
      :placeholder="true"
      active-color="#1C54CF"
      inactive-color="#d5d2d8"
    >
      <van-tabbar-item replace :to="{ name: 'index' }" icon="shouye">
        首页
      </van-tabbar-item>
      <van-tabbar-item replace :to="{ name: 'jobList' }" icon="zhiyeweisheng1">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace :to="{ name: 'companyList' }" icon="qiye">
        企业
      </van-tabbar-item>
      <van-tabbar-item v-show="!isMyPage" icon="wode" @click="toMyPage()">
        我的
      </van-tabbar-item>
      <van-tabbar-item
        v-show="isMyPage"
        icon="wode"
        @click="toMyPage()"
        style="color: #1C54CF"
      >
        我的
      </van-tabbar-item>
    </van-tabbar>
    <create-resume-dialog ref="resumeDialog"></create-resume-dialog>
  </div>
</template>

<script>
import native from "@utils/native";
import createResumeDialog from "./createResumeDialog";
import { throttle } from "@utils/index";

export default {
  name: "navbar",
  components: {
    createResumeDialog
  },
  data() {
    return {
      active: 0,
      isMyPage: false
    };
  },
  methods: {
    toMyPage: throttle(function(){
      let rtnVal = native.shmedia2.isRmtNative();
      console.log("rtnVal == " + rtnVal);
      if (rtnVal === 40) {
        // 由于延时未调用查询简历接口
        this.module.api.hasResume({
          params: {},
          success: data => {
            console.log(data,'是否有简历');
            this.$cookie.set("hasResume", data);
            if (data === true) {
              // 已有简历
              this.$router.replace({ name: "my" });
            } else {
              // 无简历
              this.showCreateResumeDia();
            }
          }
        });
      } else if (rtnVal === 10) {
        this.$router.replace({ name: "my" });
      } else if (rtnVal === 0) {
        window.AppSiteConfig.showDownDialog();
      } else if (rtnVal === 20) {
        this.module.api.hasResume({
          params: {},
          success: data => {
            console.log(data,'是否有简历');
            this.$cookie.set("hasResume", data);
            if (data === true) {
              // 已有简历
              this.$router.replace({ name: "my" });
            } else {
              // 无简历
              this.showCreateResumeDia();
            }
          }
        });
        // this.showCreateResumeDia();
      }
    },1000),
    showCreateResumeDia() {
      this.$refs.resumeDialog.isShowDia();
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.van-tabbar-item__icon .van-icon {
  font-size: 0.6rem;
}
/deep/.van-tabbar {
  box-shadow: 0 0 16px rgba(0, 0, 12, 0.06);
  height: auto;
  padding-top: 6px;
  padding-bottom: 6px;
}

/deep/.van-tabbar-item__text {
  font-size: 12px;
  color:#a5a3a7
}
/deep/.van-tabbar-item--active{
  .van-tabbar-item__text {
    color:#1C54CF
  }
}
</style>
